import Blue from "~/core";

new Blue({
	name: 'Location Detail',
	selector: ".location-detail",
	setup(container) {
		const toggle = container.querySelector(".location-detail__hours-toggle");
		const hoursToday = container.querySelector(".location-detail__hours-today");
		const hoursFull = container.querySelector(".location-detail__hours-full");
		
		if (!!toggle && !!hoursToday && !!hoursFull) {
			this.$addEvents(toggle, "click.prevent", () => {
				hoursToday.classList.toggle("inactive");
				hoursFull.classList.toggle("active");
				toggle.classList.toggle("full-open");
				if (toggle.matches(".full-open")) toggle.textContent = "See Today's Hours";
				else  toggle.textContent = "See Full Location Hours";
			});
		}
	}
});